module.exports = __webpack_public_path__ + "img/roll-747.c3f1ffe4.png";